import { render } from "./HeroBlockSection.vue?vue&type=template&id=befd430e"
import script from "./HeroBlockSection.vue?vue&type=script&lang=js"
export * from "./HeroBlockSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__